import templateUrl from './loginCorpHeader.tpl.html';

export default {
    templateUrl,
    bindings: {
        ariaLabel: '<?',
        role: '<?',
    },
    controller: [
        'DOMAIN_INFO',
        '$window',
        function (DOMAIN_INFO, $window) {
            const $ctrl = this;

            $ctrl.hasDomain = !!DOMAIN_INFO;
            if (DOMAIN_INFO) {
                const hostname = $window.location.hostname.toLowerCase();
                const isSupportedDomain =
                    hostname.endsWith('.signalfx.com') ||
                    hostname.endsWith('.observability.splunkcloud.com');

                $ctrl.fullDomain = isSupportedDomain ? hostname : DOMAIN_INFO.fullDomain;
            }
        },
    ],
};
